import * as React from "react";
import "./MethodImage.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";

const MethodImage = (props) => {
  const sizeClass = `method-desktop-image-${props.size}`;
  const methodImageClass = `method-desktop-image`;
  const backgroundColorClass = ` method-desktop-image-background-${props.background}`;
  return (
    <div className={methodImageClass + backgroundColorClass}>
      <GatsbyImage
        image={getImage(props.src)}
        imgClassName={sizeClass}
        alt=""
      />
    </div>
  );
};

MethodImage.propTypes = {
  src: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
};

export default MethodImage;
